import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import historyImage from '@assets/images/history-header.png';
import { officeDataSelector } from '@selectors/global';

const HeaderBackgroundImage = () => {
  const office = useSelector(officeDataSelector);
  const usingHistoryDb = office.match(/.+History$/);

  if (!usingHistoryDb) {
    return null;
  }

  return (
    <img
      src={historyImage}
      style={{
        position: 'absolute',
        backgroundSize: 'cover',
        minHeight: '100%',
        maxWidth: '100%',
        marginRight: '-14px',
        marginTop: '-7px',
      }}
    />
  );
};

HeaderBackgroundImage.propTypes = {
  style: PropTypes.any,
};

export default HeaderBackgroundImage;
